export const LevelTitle = {
  1: "کد حساب کل",
  2: "کد حساب معین",
  3: "کد حساب سطح سه",
  4: "کد حساب سطح چهار",
  5: "کد حساب سطح پنج",
  6: "کد حساب سطح شش"
};

export const MAX_LEVEL = 20;
export const LEVELS = () => {
  let levels = {
    1: "کل",
    2: "معین"
  };
  const generalLevelName = "سطح";
  for (let i = 3; i <= MAX_LEVEL; i++) {
    levels[i] = `${generalLevelName} ${i}`;
  }
  return levels;
};

export const TYPES = {
  CONSTANT: 1,
  EMPTY: 2,
  COST_CENTER: 3,
  CONTACT: 4,
  TEAM: 5,
  SUB_ACCOUNT_TITLE: 6
};
export const getTypeObjects = (multiLevel = true) => {
  return [
    { type: TYPES.CONSTANT, value: "کد ثابت" },
    { type: TYPES.EMPTY, value: "خالی" },
    { type: TYPES.COST_CENTER, value: "کد مرکز هزینه" },
    { type: TYPES.CONTACT, value: "کد طرف حساب" },
    { type: TYPES.TEAM, value: "کد تیم تنخواه‌داری" },
    ...(multiLevel
      ? [{ type: TYPES.SUB_ACCOUNT_TITLE, value: "کد زیر سرفصل‌حساب" }]
      : [])
  ];
};

export const getTypeObject = type => {
  return getTypeObjects().filter(typeObj => typeObj.type === type)[0];
};

export const ACCOUNTING_FIELDS_KEYS = {
  ACCOUNTING_SOFTWARE: "accounting_software",
  SUB_ACCOUNTING_SOFTWARE: "sub_accounting_software",
  ACCOUNTING_CODES: "accounting_codes",
  VAT_ACCOUNTING_CODES: "vat_accounting_codes"
};
